import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-404"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12.315 2.086a3.146 3.146 0 0 0-.396.04 4.675 4.675 0 0 0-7.838 0 3.146 3.146 0 0 0-.396-.04 3.184 3.184 0 1 0 1.243 6.116 4.61 4.61 0 0 0 6.144 0 3.185 3.185 0 1 0 1.243-6.116zm0 5.369a2.17 2.17 0 0 1-.852-.173 1 1 0 0 0-1.05.167 3.61 3.61 0 0 1-4.827 0 1 1 0 0 0-1.049-.167 2.185 2.185 0 1 1-.852-4.196 1.236 1.236 0 0 1 .17.018l.101.014a1 1 0 0 0 .962-.444 3.675 3.675 0 0 1 6.164 0 1 1 0 0 0 .962.444l.102-.014a1.236 1.236 0 0 1 .17-.018 2.184 2.184 0 1 1 0 4.369zm-7.79 5.254a1 1 0 1 0 2 0 6.603 6.603 0 0 0-1-2 6.603 6.603 0 0 0-1 2zm6.935-.113-.664-.383.658-.38a.35.35 0 0 0-.35-.606l-.658.38v-.768a.35.35 0 1 0-.7 0v.768l-.657-.38a.35.35 0 0 0-.35.606l.657.38-.664.383a.35.35 0 1 0 .35.607l.665-.384v.76a.35.35 0 1 0 .699 0v-.76l.665.384a.35.35 0 0 0 .35-.607z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }